import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export const EMISSION_REJECT_COMMENT_MAX_LENGTH = 100;

@Component({
  standalone: false,
  selector: 'app-emission-reject-analysis-modal',
  templateUrl: './emission-reject-analysis-modal.component.html',
  styleUrls: ['./emission-reject-analysis-modal.component.scss'],
})
export class EmissionRejectAnalysisModalComponent implements OnChanges {
  @Input() open = false;
  @Input() projectName = '';
  @Output() openChange = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<string>();

  selectedAction = 'correction';
  comment = '';
  projectNameValue = '';
  commentError = false;
  readonly commentMaxLength = EMISSION_REJECT_COMMENT_MAX_LENGTH;

  get commentLength(): number {
    return this.comment?.length ?? 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectName']) {
      this.projectNameValue = this.projectName;
    }
  }

  onModalDismiss(): void {
    this.resetForm();
    this.openChange.emit(false);
  }

  onCancel(): void {
    this.onModalDismiss();
  }

  onConfirm(): void {
    const trimmedComment = this.comment.trim();

    if (!trimmedComment) {
      this.commentError = true;
      return;
    }

    this.confirmed.emit(trimmedComment);
    this.resetForm();
  }

  onCommentChange(value: string): void {
    if (value.length > this.commentMaxLength) {
      this.comment = value.slice(0, this.commentMaxLength);
    }

    if (this.commentError && this.comment.trim()) {
      this.commentError = false;
    }
  }

  private resetForm(): void {
    this.selectedAction = 'correction';
    this.comment = '';
    this.commentError = false;
  }
}
